import { HoldingEventDto, HoldingEventRes } from '@dealstack/shared/lib/generated';

export type CombinedEventDto = HoldingEventDto | HoldingEventRes;

/**
 * Type guard to distinguish between transaction events (HoldingEventDto) and holding events (HoldingEventRes)
 *
 * @param event - The event to check
 * @returns true if the event is a transaction event (HoldingEventDto), false if it's a holding event (HoldingEventRes)
 *
 * Logic:
 * - HoldingEventRes always has an 'id' field, HoldingEventDto never does
 * - HoldingEventDto has transaction-specific fields like 'units' and 'sourceDisplayName'
 */
export const isHoldingEventDto = (event: CombinedEventDto): event is HoldingEventDto => {
	if ('id' in event) {
		return false;
	}

	return 'units' in event && 'sourceDisplayName' in event;
};
